<h6>{{ group.label | translate }}</h6>

<!-- Optional search within filter options -->
@if (group.searchable) {
  <div class="search-input">
    <img src="icons/search.png" alt="Search" />
    <input
      type="search"
      [(ngModel)]="filterSearch"
      (ngModelChange)="onSearchChange($event)"
      [placeholder]="'FILTERS.SEARCH' | translate"
      aria-label="filter search" />
  </div>
}

<!-- Checkbox options -->
<ul [class.loading]="group.loading" class="mb-0">
  @for (option of group.options; track option.value; let idx = $index) {
    <li>
      <div class="form-check m-0 d-flex align-items-center gap-2" (click)="onItemClick($event, option.value)" style="cursor: pointer;">
        <input
          class="form-check-input mt-0"
          type="checkbox"
          [checked]="isSelected(option.value)"
          (change)="onToggle(option.value)"
          [id]="'filter_' + group.key + '_' + idx" />
        <label class="form-check-label" [for]="'filter_' + group.key + '_' + idx" style="cursor: pointer; user-select: none;">
          {{ option.label }} @if (option.count != null) { <span class="text-muted">({{ option.count }})</span> }
        </label>
      </div>
    </li>
  }
</ul>

<!-- Show more -->
@if (group.hasMore) {
  <button class="btn-more" (click)="onLoadMore()" [disabled]="group.loading">
    <span>{{ 'FILTERS.SHOW_MORE' | translate }} {{ group.totalCount - group.options.length }}</span>
    <img src="icons/chevron.png" alt="More" />
  </button>
}
